module.exports = __webpack_public_path__ + "static/media/pr-volt-white.0ffa0490.png";